module.exports = __webpack_public_path__ + "static/media/kidsartkids_01_B.3625bd82.png";